import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useRef, useState } from "react";
import styled from "styled-components";
import React from 'react';
import { NavLink } from "react-router-dom";
const { innerWidth: width, innerHeight: height } = window;
const routes = [
  { to: "/", label: "Home" },
  
  { to: "/project", label: "Project", childs: [{ to: "/description", label: "Description" },{ to: "/engineering", label: "Engineering" }, { to: "/hardware", label: "Hardware" }, { to: "/implementation", label: "Implementation" }, { to: "/entrepreneurship", label: "Entrepreneurship" }, { to: "/contribution", label: "Contribution" }] },
  { to: "/lab", label: "Lab", childs: [{ to: "/lab_goals", label: "Lab Goals" },{ to: "/model", label: "Model" }, { to: "/mst", label: "MST"}, { to: "/elona", label: "ELONA"}, {to: "/lfa", label: "LFA"}, { to: "/lab_journal", label: "Lab Journal" }, { to: "/proof-of-concept", label: "Proof of Concept" }] },
  // { to: "/lab", label: "Lab", childs: [{ to: "/model", label: "Model" }, { to: "/drylab", label: "Experiments", childs: [{ to: "/experiments", label: "Experiments" }, { to: "/notebook", label: "Lab logbook" }, { to: "/proof-of-concept", label: "Proof of Concept" }] }, { to: "/results", label: "Lab Results" }] },

  { to: "/parts", label: "Parts" },
  { to: "/safety", label: "Safety" },
  // { to: "/integratedhumanpractice", label: "Human Practices", childs: [{ to: "/human-practices", label: "Integrated Human Practices" }, { to: "/communication", label: "Education & Science Communication" }, , { to: "/education", label: "Education" }, { to: "/collaborations", label: "Collaborations" }, { to: "/partnership", label: "Partnership" }] },
  { to: "/integratedhumanpractice", label: "Human Practices", childs: [{ to: "/human-practices", label: "Integrated Human Practices" }, { to: "/education", label: "Education" }, { to: "/collaborations", label: "Collaborations" }] },

  { to: "/team", label: "Team", childs: [{ to: "/team", label: "Team members" }, { to: "/attributions", label: " Attributions" }, { to: "/inclusivity", label: "Inclusivity" }] },
  
  { to: "/Awards", label: "Awards" }
];



const Headers = styled.header`
  
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  color: var(--white);
  position: fixed;
  top:0;
  left:0;
  z-index: 500;
  @media only Screen and (max-width: 64em) {
    padding: 0.5rem 3rem;
  }
  @media only Screen and (max-width: 40em) {
    padding: 0.5rem 1.5rem;
  }
`;

const Nav = styled.nav`
  width: 100%;
  
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  transition: all 0.3s;
  @media only Screen and (max-width: 48em) {
    display: none;
  }
  a {
    font-weight: 600;
    line-height: 1.5;
    color: var(--white);
    &::after {
      content: "";
      display: block;
      height: 3px;
      width: 0;
      transition: width 0.5s;
    }
    &:not(:last-child):hover::after {
      width: 100%;
    }
    /* &:not(:last-child) {
      margin-right: 2rem;
    } */
    /* @media only Screen and (max-width: 48em) {
      &:not(:last-child) {
        margin-right: 1rem;
      }
    } */
  }
`;


const HamburgerBtn = styled.button`
  display: none;
  @media only Screen and (max-width: 48em) {
    display: inline-block;
  }
  margin-right: 30px;
  position: relative;
  background-color: transparent;
  width: 2rem;
  height: 2px;
  margin-top: 0rem;
  transition: all 0.3s;
  cursor: pointer;
  border:none;
  &::before,
  &::after {
    content: "";
    background-color: #FFF;
    width: 2rem;
    height: 2px;
    display: inline-block;
    position: absolute;
    left: 0;
    cursor: pointer;
    transition: all 0.3s;
  }
  &::before {
    top: ${(props) => (props.clicked ? "10px" : "0.5rem")};
    transform: ${(props) => (props.clicked ? "rotate(135deg)" : "rotate(0)")};
  }
  &::after {
    top: ${(props) => (props.clicked ? "10px" : "1.5rem")};
    transform: ${(props) => (props.clicked ? "rotate(-135deg)" : "rotate(0)")};
  }
`;

const MobileMenu = styled.nav`
  display: none;
  @media only Screen and (max-width: 48em) {
    display: flex;
  }
  z-index: 99999;
  
  background:#314f72 !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  opacity: ${(props) => (props.clicked ? "1" : 0)};
  visibility: ${(props) => (props.clicked ? "visible" : "hidden")};
  transition: all 0.5s;
  z-index: -10;
  background-color: rgb(53 53 63 / 95%);
  border-radius: 20px;
  a {
    color: var(--white);
    font-weight: 600;
    font-size: 1.5rem;
    margin: 1.5rem;
    cursor: pointer;
  }
  margin: 0;
  z-index: 99999;
  overflow: scroll;
  height: 100vh;
  padding: 0;
  top: 0;
  width: 100vw !important;
  margin: 0;

  align-items: flex-start;
`;
const Header = () => {
  const [click, setClick] = useState(false);
  //const handleClick = () => setClick(!click);
  const ref = useRef(null);

  gsap.registerPlugin(ScrollTrigger);

  // const scrollUp = (id, e) => {
  //   e.preventDefault();
  //   const element = document.getElementById(id);
  //   element.scrollIntoView({
  //     behavior: "smooth",
  //     block: "end",
  //     inline: "nearest",
  //   });
  // };
  const WidthDropDown = ({ route }) => {
    const [dropdown, setDropdown] = useState(false);
    return (
      <>
      

        <div className="rightdropdownClick" onMouseEnter={() => innerWidth > 768 ? setDropdown(true) : ""} onMouseLeave={() => innerWidth > 768 ?setDropdown(false):""} onClick={() => setDropdown((prev) => !prev)}>
          <div className="text">
            {route.label}
          </div>
          <div className="rightdropdown" onClick={() => setDropdown((prev) => !prev)} style={{ display: dropdown ? 'block' : 'none' }}>
            {
              route.childs.map(route => {
                return (
                  <NavLink strict exact to={route.to} key={route.to}>
                    {route.label}
                  </NavLink>
                )
              })
            }
            
          </div>
        </div>
      </>
      
    )
  }
  const MenuItems = ({route}) => {
    const [dropdown, setDropdown] = useState(false);
    
    return (
      <>
        {route.childs ? (
          <div className="menuitem" key={route.to} onMouseEnter={() => innerWidth > 768 ? setDropdown(true) : ""} onMouseLeave={() => innerWidth > 768 ? setDropdown(false):""} onClick={() => setDropdown((prev) => !prev)} >
            <div
              
              aria-expanded={dropdown ? "true" : "false"}
              
            >
              {route.label}{" "}
            </div>
            <div className="dropDown" onClick={() => setDropdown((prev) => !prev)} style={{ display: dropdown ? 'block' : 'none' }} >
              {
                route.childs.map(route=>{
                  if (route.childs){
                    
                    return (
                      <WidthDropDown route={route} />
                      
                    )
                  }else{
                    return (
                      <NavLink strict exact to={route.to} key={route.to}>
                        {route.label}
                      </NavLink>
                    )
                    
                  }
                  
                })
              }
            </div>
          </div>
        ) : (

            <NavLink className="main" strict exact to={route.to} key={route.to}>
              {route.label}
            </NavLink>
   )}
      </>
    );
  };

  const links = routes.map((route) => {
    return (
      <MenuItems key={route.to} route={route} />
    )
  });

  return (
    <Headers ref={ref}>
      <a className="logot" href="/cityu-hongkong/">
      <img 
        src="https://static.igem.wiki/teams/5334/bevatech-logo-color-new.png" 
        alt="Logo" 
        style={{ 
          width: '250px', // Adjust as needed
          height: 'auto', // Maintain aspect ratio
          paddingLeft: '25px',
          paddingTop: '5px',
          borderRadius: '10px', // Optional: Add border-radius if desired
        }} 
      />
    </a>
      <Nav className="navigation">
        {links}
      </Nav>
      <HamburgerBtn clicked={click} onClick={() => setClick(!click)}>
        <span></span>
      </HamburgerBtn>
      <MobileMenu clicked={click}>
        
        {links}
      </MobileMenu>
    </Headers>
  );
};

export default Header;